<div class="flex-fill d-flex flex-column">
    <div class="d-flex flex-row">
        <div class="me-3"><span class="color-block negative-projected-inventory"></span> - Depleted Parts</div>
        <div class="me-3"><span class="color-block weld-low-inventory"></span> - Qty Below ReOrder Trigger</div>
    </div>
    <div class="d-flex flex-row align-items-center m-2">
        <label class="m-1">Categories</label>
        <dx-tag-box
            [dataSource]="categories"
            [(value)]="selectedCategories"
            [showSelectionControls]="true"
            [showDropDownButton]="true"
            width="250px"
        ></dx-tag-box>
        <button type="button"class="btn btn-success ms-1" (click)="search()">Search</button>
    </div>
    <div class="m-1 grid-fill" *ngIf="weldShopParts">
        <dx-data-grid
            #dataGrid
            [dataSource]="weldShopParts"
            keyExpr="partLinkId"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="subPartNumber" [groupIndex]="0" ></dxi-column>
            <dxi-column dataField="subPartNumberDisplay" caption="WeldShopPart" width="350"></dxi-column>
            <!-- <dxi-column dataField="subInStock" width="150"></dxi-column> -->
            <!-- <dxi-column dataField="subpartReOrderMin" width="150"></dxi-column> -->
            <!-- <dxi-column dataField="subpartReOrderQty" width="150"></dxi-column> -->
            <dxi-column dataField="partNumber" width="350"></dxi-column>
            <dxi-column dataField="partInStock" caption="InStock" width="100"></dxi-column>
            <dxi-column dataField="partAllocated" caption="Allocated" width="100"></dxi-column>
            <dxi-column dataField="partsNeeded" caption="Prj.Inv." width="100"></dxi-column>
            <dxi-column dataField="partLinkQty" caption="Parts/Assem." width="150"></dxi-column>
            <dxi-column dataField="partOrderedQty" caption="Parts on Order" width="150"></dxi-column>
            <!-- <dxi-column dataField="partExtendedQty" width="150"></dxi-column> -->
            <!-- <dxi-column dataField="partReOrderMin" caption="ReOrder Min" width="150"></dxi-column> -->
            <!-- <dxi-column dataField="partReOrderQty" caption="ReOrder Qty" width="150"></dxi-column> -->
            <dxi-column width="150"></dxi-column>
            <!-- <dxi-column dataField="partId" width="150"></dxi-column> -->
            <!-- <dxi-column dataField="subPartId" width="150"></dxi-column> -->
            <!-- <dxi-column dataField="created" width="150"></dxi-column> -->

            <dxo-summary>
                <dxi-group-item column="subInStock" displayFormat="In Stock: {0}" summaryType="max" [showInGroupFooter]="false"> </dxi-group-item>
                <dxi-group-item column="subpartOrderedQty" displayFormat="Parts On Order: {0}" summaryType="max" [showInGroupFooter]="false"> </dxi-group-item>
                <dxi-group-item column="subpartReOrderMin" displayFormat="Reorder Trigger: {0}" summaryType="max" [showInGroupFooter]="false"> </dxi-group-item>
                <dxi-group-item column="negativeQty" displayFormat="Neg.Qty {0}" summaryType="max" [showInGroupFooter]="true" showInColumn="partsNeeded"> </dxi-group-item>
                <dxi-group-item class="low-inventory" column="remainingQty" displayFormat="Remaining {0}" summaryType="max" [showInGroupFooter]="true" showInColumn="partLinkQty"> </dxi-group-item>
            </dxo-summary>

            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-search-panel *ngIf="!showAsDialog" class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export *ngIf="!showAsDialog" [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="!showAsDialog" type="localStorage" storageKey="weld-shop-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="weldShopParts" class="me-3"><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span>
            </div>
        </dx-data-grid>
    </div>
</div>
